/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

/* Qlik */
import useQlikSessionObject from 'hooks/useQlikSessionObject';
import AppContext from '../AppContext';

const styles = () => ({
  table: {
    fontSize: '14px',
    borderCollapse: 'collapse',
    borderSpacing: '0',
    width: '100%',
  },
  scrollTable: {
    height: '300px',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  thead: {
    fontFamily: 'League Gothic',
  },
  tblBody: {
    fontFamily: 'Roboto',
    fontSize: '13px',
  },
});

const Table = ({
  classes,
  dimensions,
  measures,
  headings,
  sortCol,
  colStyles,
  colHeadStyles,
  qHeight,
  displayOrder,
  firstColIsId,
  isChart,
  age,
  matches,
}) => {
  const qlikApp = useContext(AppContext);

  const qTableData = useQlikSessionObject({
    app: qlikApp,
    properties: {
      qInfo: {
        qType: 'vis',
      },
      qHyperCubeDef: {
        qDimensions: dimensions,
        qMeasures: measures,
        qInitialDataFetch: [
          {
            qWidth: 10,
            qHeight,
          },
        ],
        qInterColumnSortOrder: [sortCol], // sort by second column
      },
    },
  });

  const getFlagImage = (country) => {
    switch (country) {
      case 'Argentina':
        return 'ARG';
      case 'Australia':
        return 'AUS';
      case 'Belgium':
        return 'BEL';
      case 'Brazil':
        return 'BRA';
      case 'Cameroon':
        return 'CMR';
      case 'Canada':
        return 'CAN';
      case 'Costa Rica':
        return 'CRC';
      case 'Croatia':
        return 'CRO';
      case 'Denmark':
        return 'DNK';
      case 'Ecuador':
        return 'ECU';
      case 'England':
        return 'ENG';
      case 'France':
        return 'FRA';
      case 'Germany':
        return 'GER';
      case 'Ghana':
        return 'GHA';
      case 'Iran':
        return 'IRN';
      case 'Japan':
        return 'JPN';
      case 'South Korea':
        return 'KOR';
      case 'Mexico':
        return 'MEX';
      case 'Morocco':
        return 'MAR';
      case 'Netherlands':
        return 'NED';
      case 'Poland':
        return 'POL';
      case 'Portugal':
        return 'PRT';
      case 'Qatar':
        return 'QAT';
      case 'Saudi Arabia':
        return 'KSA';
      case 'Senegal':
        return 'SEN';
      case 'Serbia':
        return 'SER';
      case 'Spain':
        return 'ESP';
      case 'Switzerland':
        return 'SUI';
      case 'Tunisia':
        return 'TUN';
      case 'Uruguay':
        return 'URU';
      case 'United States':
        return 'USA';
      case 'Wales':
        return 'WAL';
      default:
        return 'undefined';
    }
  };

  const table = useMemo(() => {
    if (!qTableData.layout) return [];
    let qlikDataWinMatchup = [];
    if (qTableData.layout.qHyperCube.qError) {
      qlikDataWinMatchup = [];
    } else {
      // eslint-disable-next-line prefer-destructuring
      qlikDataWinMatchup = qTableData.layout.qHyperCube.qDataPages[0].qMatrix;
    }
    return qlikDataWinMatchup;
  }, [qTableData.layout]);

  const getFormatedStringFromDays = (numberOfDays) => {
    const years = Math.floor(numberOfDays / 365);
    const months = Math.floor((numberOfDays % 365) / 30);
    const days = Math.floor(numberOfDays % 365);

    const yearsDisplay = years > 0 ? years + (years === 1 ? 'y ' : 'y ') : '';
    const monthsDisplay = months > 0 ? months + (months === 1 ? 'm ' : 'm ') : '';
    const daysDisplay = days > 0 ? days + (days === 1 ? 'd' : 'd') : '';
    return yearsDisplay + monthsDisplay + daysDisplay;
  };

  return (
    <div>

      <div className={!matches && classes.scrollTable}>
        <table className={matches && classes.table}>
          <thead className={classes.thead}>
            <tr className={classes.tr}>
              {headings.map((heading, i) => (
                <th style={{ fontWeight: '500' }} key={displayOrder ? headings[displayOrder[i]] : heading}>
                  <div style={{ whiteSpace: 'nowrap', ...colHeadStyles[i] }}>
                    {displayOrder ? headings[displayOrder[i]] : heading}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className={classes.tblBody}>
            {
        table.map((row) => (
          <tr key={row[0].qElemNumber}>
            {row.map((col, i) => (
              (firstColIsId && i === 0) ? null : (

                <td key={i}>
                  {' '}
                  {/* eslint-disable-line react/no-array-index-key */}
                  <div style={{
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    paddingRight: `${matches ? '0' : '1em'}`,
                    ...colStyles[i],
                  }}
                  >
                    {(displayOrder ? row[displayOrder[i]].qAttrExps : col.qAttrExps)
                        && (
                        <img
                          style={{ width: 15, height: 10, margin: '0 5px 0px 5px' }}
                          src={`assets/images/st_flags/${displayOrder
                            ? getFlagImage(row[displayOrder[i]].qText)
                            : col.qAttrExps.qValues[0].qText}.png`}
                          alt={displayOrder
                            ? row[displayOrder[i]].qText
                            : col.qAttrExps.qValues[0].qText}
                        />
                        )}
                    {!(isChart && i === 2)
                        && (displayOrder
                          ? `${row[displayOrder[i]].qText}`
                          : (i === 0 ? col.qText : (age ? getFormatedStringFromDays(col.qText) : col.qText)))}
                    {(isChart && i === 2)
                        && <div style={{ width: `${col.qText}%`, height: 10, backgroundColor: `rgba(99,173,31,${Number(col.qText) / 100})` }} />}
                  </div>
                </td>

              )
            ))}
          </tr>
        ))
        }
          </tbody>
        </table>
      </div>
    </div>
  );
};

Table.propTypes = {
  classes: PropTypes.object.isRequired,
  dimensions: PropTypes.array,
  measures: PropTypes.array,
  headings: PropTypes.array,
  sortCol: PropTypes.number,
  colStyles: PropTypes.array,
  colHeadStyles: PropTypes.array,
  qHeight: PropTypes.number,
  displayOrder: PropTypes.array,
  firstColIsId: PropTypes.bool,
  isChart: PropTypes.bool,
  age: PropTypes.bool,
  matches: PropTypes.bool,
};

Table.defaultProps = {
  dimensions: [],
  measures: [],
  headings: [],
  sortCol: 0,
  colStyles: [],
  colHeadStyles: [],
  qHeight: 1000,
  displayOrder: null,
  firstColIsId: false,
  isChart: false,
  age: false,
  matches: false,
};

export default injectSheet(styles)(Table);
